// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0f9d504e","513":"623a6e4b","703":"b53ddfc2"}[chunkId] + ".chunk.js";
};